import { render, staticRenderFns } from "./PopupContent.vue?vue&type=template&id=74fc2d52&scoped=true&"
import script from "./PopupContent.vue?vue&type=script&lang=js&"
export * from "./PopupContent.vue?vue&type=script&lang=js&"
import style0 from "./PopupContent.vue?vue&type=style&index=0&id=74fc2d52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fc2d52",
  null
  
)

export default component.exports